import { render, staticRenderFns } from "./TabletNicheOverview.vue?vue&type=template&id=8dbd0d5e"
import script from "./TabletNicheOverview.vue?vue&type=script&lang=js"
export * from "./TabletNicheOverview.vue?vue&type=script&lang=js"
import style0 from "./TabletNicheOverview.vue?vue&type=style&index=0&id=8dbd0d5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports